<template>
  <div id="version-history-wrapper">
    <div class="version">
      <span class="version-number">Version 0.1.12</span>
      <span class="version-release-date">Release date 10.12.2019</span>
      <ul class="version-change-list">
        <li>Fix blood pressure measurement editing</li>
      </ul>
    </div>

    <div class="version">
      <span class="version-number">Version 0.1.11</span>
      <span class="version-release-date">Release date 10.12.2019</span>
      <ul class="version-change-list">
        <li>Welcome view ui changes</li>
        <li>Add blood sugar and blood pressure measurements to measurement count</li>
        <li>Fix blood pressure measurement sorting</li>
        <li>Fix empty scale comment handling in weighing result card</li>
      </ul>
    </div>

    <div class="version">
      <span class="version-number">Version 0.1.10</span>
      <span class="version-release-date">Release date 1.12.2019</span>
      <ul class="version-change-list">
        <li>Add blood sugar and blood pressure measurements</li>
        <li>Subview state handling from store to router</li>
        <li>Move scales from main navigation to weight view</li>
        <li>Hide profile view chart Y axis label</li>
        <li>Fix weighing result and waist measurement cancel button functionality when the views are opened from the profile view</li>
        <li>Add scale comment to weighing result card</li>
      </ul>
    </div>

    <div class="version">
      <span class="version-number">Version 0.1.9</span>
      <span class="version-release-date">Release date 9.11.2019</span>
      <ul class="version-change-list">
        <li>Chart Y axis scaling is now based on minimum and maximum measurement values</li>
        <li>Chart step size to 5</li>
        <li>Profile view quick links for creating measurements</li>
      </ul>
    </div>

    <div class="version">
      <span class="version-number">Version 0.1.8</span>
      <span class="version-release-date">Release date 16.9.2019</span>
      <ul class="version-change-list">
        <li>Changed logo format to svg and other small ui tweaks</li>
        <li>Improvements to chart scaling</li>
        <li>Shortened profile chart labels</li>
        <li>Replaced date picker components with standard html5 date inputs</li>
        <li>Changed waist and weight measurement input field type from text to number</li>
      </ul>
    </div>

    <div class="version">
      <span class="version-number">Version 0.1.7</span>
      <span class="version-release-date">Release date 15.9.2019</span>
      <ul class="version-change-list">
        <li>Added "fasted selection" to weighing result create and edit views. The selection defaults to true.</li>
        <li>Improvements to chart scaling</li>
        <li>Added chart scaling buttons</li>
      </ul>
    </div>

    <div class="version">
      <span class="version-number">Version 0.1.6</span>
      <span class="version-release-date">Release date 12.9.2019</span>
      <ul class="version-change-list">
        <li>Added router scroll history</li>
        <li>Minor UI improvements</li>
        <li>Forced secure https connection</li>
        <li>Improved CORS handling</li>
        <li>Improved state handling for waist and weight views (chart filter states are still not stored)</li>
        <li>Implemented waist and weight chart date filtering (filters default to the first the day of the year to current date)</li>
      </ul>
    </div>

    <div class="version">
      <span class="version-number">Version 0.1.5</span>
      <span class="version-release-date">Release date 8.9.2019</span>
      <ul class="version-change-list">
        <li>Now only 30 most recent measurements from the past year are displayed in the Profile view chart</li>
        <li>Replaced time pickers with standard html5 time inputs</li>
        <li>Waist circumference and body weight measurement charts (known issues with date range selection)</li>
        <li>UI improvements to measurement cards, button logic, nav, and so on...</li>
      </ul>
    </div>

    <div class="version">
      <span class="version-number">Version 0.1.4</span>
      <span class="version-release-date">Release date 4.9.2019</span>
      <ul class="version-change-list">
        <li>Added measurement sorting functionality</li>
        <li>Improvements to measurement and scale edit logic</li>
      </ul>
    </div>

    <div class="version">
      <span class="version-number">Version 0.1.3</span>
      <span class="version-release-date">Release date 27.8.2019</span>
      <ul class="version-change-list">
        <li>Removed scale manufacturer/model uniqueness conditions</li>
        <li>Fixed weight view typo</li>
      </ul>
    </div>

    <div class="version">
      <span class="version-number">Version 0.1.2</span>
      <span class="version-release-date">Release date 25.8.2019</span>
      <ul class="version-change-list">
        <li>Added version history view</li>
        <li>Scale view updates. Removed in-view components and added separate create and edit views for uniformity.</li>
        <li>Added scale comments</li>
      </ul>
    </div>

    <div class="version">
      <span class="version-number">Version 0.1.1</span>
      <span class="version-release-date">Release date 18.8.2019</span>
      <ul class="version-change-list">
        <li>Welcome view updates</li>
        <li>User count</li>
        <li>UI adjustments</li>
        <li>Fixed measurement time clearing issues</li>
      </ul>
    </div>

    <div class="version">
      <span class="version-number">Version 0.1.0</span>
      <span class="version-release-date">Release date 18.8.2019</span>
      <ul class="version-change-list">
        <li>First release</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "VersionHistory",
  components: {},
  data: function() {
    return {
      info: {}
    };
  },
  created: function() {}
};
</script>

<style scoped>
#version-history-wrapper {
}

.version {
}

.version-number {
  display: block;
  font-size: 120%;
  color: #111;
}

.version-release-date {
  display: block;
  font-size: 90%;
  color: gray;
}

.version-change-list {
  margin-top: 0.5em;
  font-size: 90%;
}
</style>

